import type { Language } from '@application/types';
import type { ModalData } from '../Modal';

export interface SelectPreferredCountryLanguageFormValues {
  country: string;
}

export interface SelectPreferredCountryLanguageModalData {
  modal: ModalData;
  language?: Language;
}

export interface SelectPreferredCountryLanguageModalProps
  extends SelectPreferredCountryLanguageModalData {}
